module.exports = __webpack_public_path__ + "img/N9 200X200.80667b17.png";